import axios from "axios";
import { toast } from "react-toastify";
import {
  OrganisationBranchApi,
  OrganisationProfileAPI,
  PoBudgetDownloadApi,
} from ".";

export const fetchOrganisationDetails = () => {
  return axios
    .get(`${OrganisationProfileAPI}`)
    .then((res) => {
      if (res?.data?.length > 0) {
        return res?.data[0];
      }
      return false;
    })
    .catch(() => {});
};

export const fetchOrganisationBranches = () => {
  return axios.get(`${OrganisationBranchApi}`).then((res) => {
    return res?.data;
  });
};

export const fetchOrganisationCategories = () => {
  return axios.get("apiV1/organisation-item-category/").then((res) => {
    return res.data;
  });
};

export const downloadPoBudgetData = (params = {}) => {
  return axios
    .get(`${PoBudgetDownloadApi}`, {
      params: { ...params },
      responseType: "blob",
    })
    .then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTLM element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "Budget File of po raised.csv"); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      return response?.data;
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};
